import api from '.';
import { ApprovalPeriod } from '../pages/ProjectApprovalPeriod/projectApprovalPeriodSlice';

export async function getProjectApprovalPeriods(projectId: number) {
  const params = { projectId };

  const { data } = await api.get(`/project-approval-periods`, { params });
  return data;
}
export async function updateProjectApprovalPeriod({
  projectId,
  approvalPeriods
}: {
  projectId: number;
  approvalPeriods: ApprovalPeriod[];
}) {
  const { data } = await api.put(`/project-approval-periods`, {
    projectId,
    approvalPeriods
  });
  return data;
}
